import { Box, IconButton } from '@material-ui/core';
import React, { ReactElement } from 'react';
import AddIcon from '@material-ui/icons/Add';

export interface ICreateButtonProps {
	disabled?: boolean;
	onClick: React.MouseEventHandler<HTMLButtonElement>;
}

export function CreateButton(props: ICreateButtonProps): ReactElement {
	const { disabled, onClick } = props;
	return (
		<Box display="flex" justifyContent="flex-end">
			<IconButton
				onClick={onClick}
				disabled={
					disabled === undefined ? false : (disabled as boolean)
				}
			>
				<AddIcon />
			</IconButton>
		</Box>
	);
}
